import {Table, TableInput, TableUpdate} from "../../../api/graphql";

export abstract class TableRepository {
    public abstract getTables(): Promise< Table[] >
    public abstract getTable(id: string): Promise<Table>
    public abstract updateTable(id: string, updateTable: TableUpdate): Promise<string>
    public abstract addTable(newTable: TableInput): Promise<Table>
    public abstract removeTable(id: string): Promise<boolean>
}
